/* global XMLHttpRequest */
let URL_BASE, URL_API, URL_FRONT, LDAP_CHECK_CONNEXION, ALERT_DURATION;

function initConfigurations() {
  const request = new XMLHttpRequest();
  request.open('GET', '/config.json', false); // `false` makes the request synchronous
  request.send(null);

  if (request.status === 200) {
    window.appConfig = JSON.parse(request.responseText);
    console.log('Configuration chargée.', window.appConfig);
    return true;
  } else {
    window.alert('Erreur de chargement de configuration.');
    return false;
  }
}

const initApp = () => {
  initConfigurations();

  URL_BASE = window.appConfig.REACT_APP_URL_BASE; // Url de l'api backend
  URL_API = window.appConfig.REACT_APP_URL_API; // Url de l'api backend
  URL_FRONT = window.appConfig.REACT_APP_URL_FRONT; // Url du front
  LDAP_CHECK_CONNEXION = (window.appConfig.REACT_APP_LDAP_CHECK_CONNEXION === '1'); // Booléen d'activation de la connexion LDAP
  ALERT_DURATION = window.appConfig.REACT_APP_ALERT_DURATION; // Délai d'affichage des alertes (en ms)
};

export { URL_BASE, URL_API, URL_FRONT, LDAP_CHECK_CONNEXION, ALERT_DURATION };
export { initApp as default };